export default class MainTabs {
  constructor(loginContainer) {
    this._loginContainer = loginContainer;
    this._tabsContainerElement = this._loginContainer.querySelector(`.js-login-head`);
    this._callback = {};

    this._currentTab = this._tabsContainerElement.querySelector(`.login__button--active`);

    this._watchTabsContainerElementClick = this._watchTabsContainerElementClick.bind(this);
    this.changeTab = this.changeTab.bind(this);
  }

  changeTab(tab) {
    if (tab !== this._currentTab) {
      this._currentTab.classList.remove(`login__button--active`);
      this._currentTab = tab;
      this._currentTab.classList.add(`login__button--active`);
    }
  }

  _watchTabsContainerElementClick(evt) {
    this._callback.elementClick(evt);
  }

  setMainTabsClickHandler(callback) {
    this._callback.elementClick = callback;
    this._tabsContainerElement.addEventListener(`click`, this._watchTabsContainerElementClick);
  }
}
